import React, { useEffect, useState } from "react";
import * as S from "./header.style.ts";
import UserIcon from "../../svg/UserIcon.tsx";
import Link from "../Link/Link.tsx";
import { useAuth } from "../../context/AuthContext.tsx";
import Button from "../Button/Button.tsx";
import { useLocation } from "react-router-dom";
import { trackPage } from "../../functions/mixpanel.ts";
import { useAtom, useSetAtom } from "jotai";
import { userAtom } from "../../hook/UserAtom.ts";
import { budgetAtom } from "../../hook/BudgetAtom.ts";
import { addUser, getBudgetInfo } from "../../functions/user.ts";
import { nonPrivatePages } from "../../constants.ts";
import { loggedInHomepage } from "../../functions/helper.ts";
import SignUpModal from "../SignUpModal/SignUpModal.tsx";

const Header = () => {
  const auth = useAuth();
  const { user, isAuthenticated } = auth;
  const location = useLocation();
  const setBudget = useSetAtom(budgetAtom);
  const [currentUser, setCurrentUser] = useAtom(userAtom);
  const [hasBudget, setHasBudget] = useState<boolean>(false);
  const [loginModal, setLoginModal] = useState<boolean>(false);

  useEffect(() => {
    if (!currentUser && nonPrivatePages.includes(location.pathname)) {
      user && addUser(auth, setCurrentUser, setHasBudget);
    }
  }, [user]);

  useEffect(() => {
    if (hasBudget) {
      getBudgetInfo(setBudget, auth);
    }
  }, [hasBudget]);

  useEffect(() => {
    trackPage(location.pathname);
  }, [location]);

  return (
    <>
      <S.HeaderWrapper>
        <S.Title>
          <Link
            label="Simple Budgeting"
            url={isAuthenticated ? loggedInHomepage(currentUser) : "/"}
          >
            Simple Budgeting
          </Link>
          <div>A HeiPro Digital Tool</div>
        </S.Title>
        <S.HeaderLinks>
          {isAuthenticated ? (
            <>
              <Link url={"/cash-flow"} label={"Cash Flow"}>
                Cash Flow
              </Link>
              <Link url={"/account"} label={"Account"}>
                <>
                  {user?.picture ? (
                    <img
                      src={user.picture}
                      alt="logged in user"
                      title="Logged in user"
                      aria-label="Logged in user"
                    />
                  ) : (
                    <UserIcon />
                  )}
                  Account
                </>
              </Link>
            </>
          ) : (
            <Button classType="text" handleClick={() => setLoginModal(true)}>
              <>
                <UserIcon />
                Sign In
              </>
            </Button>
          )}
        </S.HeaderLinks>
      </S.HeaderWrapper>
      <SignUpModal
        isOpen={loginModal}
        setIsOpen={setLoginModal}
        loginMode="signin"
      />
    </>
  );
};

export default Header;
